import * as React from 'react';

import { RangePicker, RangePickerProps } from 'components/pickers/range-picker';
import { OptionGroup, OptionGroupProps } from 'components/base/option-group';
import { Container } from 'theme/layout';

const CONTAINER_MARGIN_BOTTOM = 15;

/**
 * An incremental value picker that allows a user to step through options one at a time.
 *
 * @param props - Render props
 */
export function RangeSelector<T>(props: RangeSelectorProps<T>) {
  const { accentColor, title, description, icon, selectedValue, onChange, options } = props;

  return (
    <OptionGroup accentColor={accentColor} title={title} description={description} icon={icon}>
      <Container marginBottom={CONTAINER_MARGIN_BOTTOM}>
        <RangePicker selectedValue={selectedValue} onChange={onChange} options={options} />
      </Container>
    </OptionGroup>
  );
}
/* Type definitions */
export type RangeSelectorProps<T> = RangePickerProps<T> & OptionGroupProps;
